import { render, staticRenderFns } from "./PluginList.vue?vue&type=template&id=02668d2c&scoped=true&"
import script from "./PluginList.vue?vue&type=script&lang=js&"
export * from "./PluginList.vue?vue&type=script&lang=js&"
import style0 from "./PluginList.vue?vue&type=style&index=0&id=02668d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02668d2c",
  null
  
)

export default component.exports